import React, { useMemo, useState } from "react";
import styled from "styled-components";

const SortIconContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 12px;
  margin-left: 5px;
`;

const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 4px solid transparent; /* Thinner arrows */
  border-right: 4px solid transparent; /* Thinner arrows */
  opacity: 0.5;
  transition: opacity 0.2s;

  &.up {
    border-bottom: 6px solid black; /* Adjusted size */
    margin-bottom: 1px;
  }

  &.down {
    border-top: 6px solid black; /* Adjusted size */
    margin-top: 1px;
  }

  &.active {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

const SortIcon = ({ sortType = "" }) => {
  const sortOrder = useMemo(() => {
    return sortType;
  }, [sortType]);

  return (
    <SortIconContainer>
      <Arrow className={`up ${sortOrder === "asc" ? "active" : ""}`} />
      <Arrow className={`down ${sortOrder === "desc" ? "active" : ""}`} />
    </SortIconContainer>
  );
};

export default SortIcon;
